export default "__VITE_ASSET__DcWRmVHA__"